// extracted by mini-css-extract-plugin
module.exports = {"box":"letterDialog_box__3XGjG","content":"letterDialog_content__OWPco","exit":"letterDialog_exit__2cU9H","box_isVisible":"letterDialog_box_isVisible__19mjk"};